module.exports = __webpack_public_path__ + "static/img/title.fc7880e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fiveth/title.png
// module id = DUAd
// module chunks = 1